import React from 'react';
import { ArrowRight, Send } from 'lucide-react';
import { BRAND_NAME, SLOGAN } from '../constants';

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-slate-950 border-b border-slate-900">
      {/* Architectural Grid Background */}
      <div className="absolute inset-0 bg-[size:40px_40px] bg-grid-pattern opacity-20 pointer-events-none"></div>
      
      {/* Subtle Vignette */}
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-slate-950 pointer-events-none"></div>

      <div className="relative z-10 container mx-auto px-6 text-center max-w-5xl">
        
        <div className="flex flex-col items-center mb-12 animate-fade-in-down">
          <div className="h-12 w-[1px] bg-sage-400/50 mb-6"></div>
          <div className="inline-flex items-center gap-3 px-3 py-1 border border-slate-800 bg-slate-900/50 text-sage-400">
            <span className="w-1 h-1 bg-sage-400"></span>
            <span className="text-[10px] font-mono tracking-widest uppercase">Sistema de Análisis v3.0</span>
          </div>
        </div>
        
        <h1 className="text-5xl md:text-8xl font-extrabold text-white tracking-tighter mb-8 leading-tight">
          <span className="block opacity-90">{BRAND_NAME}</span>
          <span className="text-2xl md:text-4xl block text-slate-500 font-extralight tracking-widest mt-4 uppercase">
            Inversión Deportiva Inteligente
          </span>
        </h1>
        
        <p className="text-lg md:text-xl text-slate-400 max-w-2xl mx-auto mb-16 leading-relaxed font-light border-l-2 border-slate-800 pl-6 text-left md:text-center md:border-l-0 md:pl-0">
          {SLOGAN}
          <span className="block mt-4 text-slate-600 text-sm font-mono">
            // Sin azar. Solo estadística y gestión de capital.
          </span>
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="https://t.me/CarrionBET" 
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-8 py-5 bg-sage-400 hover:bg-sage-300 text-slate-950 font-bold tracking-wide transition-all rounded-none border border-sage-400 flex items-center justify-center gap-3 group shadow-[0_0_20px_rgba(140,171,145,0.1)] hover:shadow-[0_0_30px_rgba(140,171,145,0.2)]"
          >
            <Send size={18} className="group-hover:-translate-y-1 group-hover:translate-x-1 transition-transform" />
            <span>ACCESO AL CANAL GRATUITO</span>
          </a>
          
          <button 
            onClick={() => document.getElementById('track-record')?.scrollIntoView({ behavior: 'smooth'})} 
            className="w-full sm:w-auto px-8 py-5 bg-transparent border border-slate-800 hover:border-slate-600 text-slate-400 hover:text-white transition-all rounded-none text-sm tracking-widest uppercase hover:bg-slate-900/50"
          >
            VER TRACK RECORD
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;